import { WinningLinesCoordinate100 } from '../../gameConstants';
import { gameStore } from '../../store/gameStore';

export const handleSymbolAnimationPositionInMatrix = (winsMatrix) => {
  const winLines = [];
  let winLine = {};
  const allLinesMatrix = [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
  ];
  winsMatrix.forEach((el) => {
    const activeSymbolsMatrix = [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ];
    let winElCount = 0;
    const isFromRight = el.line > 100;
    const lineIndex = el.line - (isFromRight ? 101 : 1);
    if (el.line) {
      for (let i = isFromRight ? 4 : 0; isFromRight ? i >= 0 : i < 5; i += isFromRight ? -1 : 1) {
        const line = WinningLinesCoordinate100[lineIndex][i];
        const row = line.x;
        const coll = line.y;
        if (winElCount < el.count) {
          winElCount += 1;
          activeSymbolsMatrix[row][coll] = 1;
          allLinesMatrix[row][coll] = 1;
        } else {
          activeSymbolsMatrix[row][coll] = 2;
          allLinesMatrix[row][coll] = allLinesMatrix[row][coll] ? allLinesMatrix[row][coll] : 2;
        }
      }
    } else {
      const response = [[], [], [], []];
      const {
        spinResult: { matrix },
      } = gameStore;
      for (let i = 0; i < matrix.length; i += 1) {
        for (let j = 0; j < matrix[i].length; j += 1) {
          response[j][i] = matrix[i][j];
          if (response[j][i] === el.symbol) {
            activeSymbolsMatrix[j][i] = 1;
          }
        }
      }
    }

    winLine = {
      count: el.count,
      lines: activeSymbolsMatrix,
      allLines: allLinesMatrix,
      win: el.lineWinAmount,
      winCard: el.symbol,
      line: el.line,
    };
    winLines.push(winLine);
  });

  return winLines;
};
